const MenuNavigationFactory = function ($resource, $window, $location) {
    const getGroupMenuApi =
        "/participant-web-services/rest/menu/getGroupNavigationMenu/groupId/:groupId";
    const getAccountMenuApi = "/participant-web-services/rest/menu/getAccountMenuDetails";
    const getGroupMenuParams = {
        groupId: "@groupId"
    };

    const getAccuApi = "/participant-web-services/rest/nonauth/getAccu";

    const getAccuCodesApi = "/participant-web-services/rest/nonauth/accuCodes";

    const getLegacySSOTokenApi =
        "/participant-web-services/rest/sso/retrieveLegSSOToken/indId/:individualId/group/:groupId";
    const getLegacySSOTokenParams = {
        individualId: "@individualId",
        groupId: "@groupId"
    };

    function setLegacySiteBaseUrl() {
        if (__iframeUrl__ === "") {
            return getCurrentDomain();
        } else {
            return __iframeUrl__;
        }
    }

    function getCurrentDomain() {
        let currentDomain = $location.protocol() + "://" + $location.host();
        if ($window.location.port !== "") {
            currentDomain += ":" + $window.location.port;
        }
        currentDomain += "/";
        return currentDomain;
    }

    const legacySiteBaseURL = setLegacySiteBaseUrl();

    const ssoToLegacyApi = "authenticateLegacyApp.do";
    const ssoToLegacyChangePlansApi = "legacyChangePlan.do";
    const ssoToLegacyParams = {
        synctoken: "@synctoken",
        accu: "@accu",
        gaId: "@groupId",
        indId: "@individualId",
        param: "@uniqueVal"
    };

    return {
        getGroupMenu: $resource(__baseApiUrl__ + getGroupMenuApi, getGroupMenuParams, {
            query: {
                method: "GET",
                isArray: true
            }
        }),

        getAccountMenu: $resource(__baseApiUrl__ + getAccountMenuApi, {
            query: {
                method: "GET",
                isArray: true
            }
        }),

        getAccu: $resource(
            __baseApiUrl__ + getAccuApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: true
                }
            }
        ),

        getAccuCodes: $resource(
            __baseApiUrl__ + getAccuCodesApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: false,
                    cache: false
                }
            }
        ),

        getLegacySSOToken: $resource(
            __baseApiUrl__ + getLegacySSOTokenApi,
            getLegacySSOTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: true,
                    cache: false
                }
            }
        ),
        ssoToLegacy: $resource(legacySiteBaseURL + ssoToLegacyApi, ssoToLegacyParams, {
            query: {
                method: "GET",
                isArray: false,
                cache: false
            }
        }),
        ssoToLegacyChangeGroup: $resource(
            legacySiteBaseURL + ssoToLegacyChangePlansApi,
            ssoToLegacyParams,
            {
                query: {
                    method: "GET",
                    isArray: false,
                    cache: false
                }
            }
        )
    }; // End of return
};

MenuNavigationFactory.$inject = ["$resource", "$window", "$location"];
export default MenuNavigationFactory;
